import React from 'react';
import useHandleChangeRoute from '../../utils/useHandleChangeRoute';
import UserProfile from '../UserProfile';

export default function Profile() {
  const handleChangeRoute = useHandleChangeRoute();
  return <UserProfile handleSendEmailClick={handleChangeRoute('/SendEmail')} />;
}
